import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ActionConfirm({
    open = false,
    handleConfirm,
    handleCancel,
    handleClose = () => { },
    config = {
        title: `-`,
        renderBody: () => <>-</>,
        cancelButtonTitle: `Cancel`,
        confirmButtonTitle: `Confirm`,
        confirmButtonProps: {}
    }
}) {
    // const [open, setOpen] = React.useState(false);

    // const handleClickOpen = () => {
    //     setOpen(true);
    // };

    const handleDialogClose = () => {
        if (handleClose) handleClose()
    };

    return (
        <Dialog
            open={open}
            onClose={handleDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {
                    config.title
                }
            </DialogTitle>
            <DialogContent>
                {/* <DialogContentText id="alert-dialog-description"> */}
                {
                    config.renderBody()
                }
                {/* </DialogContentText> */}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    {config.cancelButtonTitle}
                </Button>
                <Button
                    onClick={handleConfirm}
                    autoFocus
                    {...config?.confirmButtonProps}
                >
                    {config.confirmButtonTitle}
                </Button>
            </DialogActions>
        </Dialog>
    );
}